export default {
	lang: 'fr',
	roof: 'Toit',
	facade: 'Façade',
	searchForAddress: 'Entrez l\'adresse ici...',
	address: 'Adresse',
	map: 'Carte',
	or: 'ou',
	clickOn: 'Cliquez sur un toit sur la',
	selectedAddress: 'Adresse sélectionnée',
	notYetLocalised: 'Pas encore localisé',
	indicateLocation: 'Indiquez votre emplacement',
	whatRoofType: 'Quel type de toit avez-vous ?',
	unselected: 'Choisir le type de toit',
	tile: 'Tuile',
	tin: 'Tôle',
	other: 'Autre / Inconnu',
	corrugatedEternit: 'Eternit ondulé',
	slateEternit: 'Eternit ardoise',
	gravel: 'Toit plat en gravier',
	substrate: 'Toit plat végétalisé',
	wallbox: 'Wallbox',
	wallboxDescription: 'L\'installation d\'une wallbox est un investissement tourné vers l\'avenir. Grâce à l\'interaction intelligente avec l\'installation solaire, votre flotte peut être alimentée en électricité avantageuse aujourd\'hui ou à l\'avenir.',
	backupPower: 'Alimentation de secours',
	backupPowerDescription: 'Même en cas de panne de courant, l\'installation solaire continue d\'alimenter les appareils les plus importants. Il s\'agit généralement d\'appareils tels que les congélateurs, les luminaires, le téléphone et Internet.',
	additionalOfferings: 'Offres supplémentaires',
	yourLocation: 'Emplacement du toit et contact',
	mr: 'M.',
	mrs: 'Mme',
	firstName: 'Prénom',
	surname: 'Nom',
	email: 'E-mail',
	phone: 'Téléphone',
	postalCode: 'Code postal',
	city: 'Ville',
	addressCap: 'Adresse',
	comments: 'Remarques',
	addressSameAsAbove: 'L\'adresse est la même que ci-dessus',
	state: 'Canton',
	street: 'Rue',
	submit: 'Envoyer',
	invalidEmail: 'Adresse e-mail invalide',
	invalidPhone: 'Numéro de téléphone invalide',
	invalidCaptcha: 'Le jeton CAPTCHA n\'est pas valide',
	submissionComplete: 'Demande envoyée',
	sendingData: 'Envoi des informations...',
	submissionError: 'Une erreur est survenue !',
	apiErrorMessage: 'Service indisponible : votre demande ne peut pas être traitée pour le moment.',
	apiInvalidCaptchaMessage: 'Votre jeton CAPTCHA est invalide ou a expiré. Veuillez actualiser la page et réessayer.',
	mandatoryField: 'Le champ ne doit pas être vide',
	enterCustom: 'Veuillez saisir vos données personnalisées',
	customRoof: 'Retour à la carte',
	mapMode: 'Saisie manuelle',
	length: 'Longueur',
	width: 'Largeur',
	unit: 'm',
	area: 'Surface',
	slope: 'Inclinaison',
	data: 'Données',
	pleaseEnter: 'Veuillez saisir l\'adresse de votre toit ou ajouter vos données de toit personnalisées',
	selectRoofType: 'Veuillez sélectionner votre type de toit',
	multipleRoofLabel: 'Plusieurs toits',
	clearRoofSelectionLabel: 'Réinitialiser',
	orientation: 'Orientation du toit',
	north: 'N',
	northeast: 'NE',
	east: 'E',
	southeast: 'SE',
	south: 'S',
	southwest: 'SO',
	west: 'O',
	northwest: 'NO',
	roof1: 'Toit 1',
	electricityProductionPerYear: 'Production d\'électricité par an',
	electricityProductionPerYearUnit: 'kWh',
	amountOfHouseholds: 'Nombre de ménages',
	financialReturnIn30years: 'Rendement sur 30 ans',
	financialReturnIn30yearsUnit: 'CHF',
	deleteTab: 'Supprimer le toit',
	undo: 'Annuler',
	removed: 'supprimé',
	welcomeMessage: 'Votre offre solaire personnalisée en trois minutes',
	cookieConsentBanner1: 'Notre site utilise des cookies de suivi pour effectuer des analyses détaillées et optimiser les mesures marketing.',
	cookieConsentBanner2: 'Cela nous permet d\'améliorer continuellement votre expérience utilisateur.',
	acceptButtonText: 'Accepter',
	declineButtonText: 'Refuser',
	title: "Calculateur solaire d'Elektrobedarf Troller",
	description: "L'électricité par la lumière du soleil — sélectionnez le toit, calculez le rendement et demandez une offre.",
	publisher: "Éditeur et responsable du contenu : Patrick Troller, directeur général",
	development: "Développement :",
	t2consultAddress: "Am Heidberg 14, 24211 Preetz - Allemagne",
	additionalSuccessMessage: "Merci ! Votre conseiller solaire personnel prépare maintenant votre offre individuelle.",
	consultantHint: "ⓘ Chaque offre est personnellement vérifiée par un expert solaire et adaptée à votre toit. Vos données sont traitées de manière confidentielle et ne sont pas transmises à des tiers.",
	nextStep: "Suivant",
	nextToRoofType: "Suivant : type de toit",
	directContact: "Nous contacter",
	nextToTeaser: "Suivant : aperçu",
	nextToOfferings: "Suivant : offres supplémentaires",
	nextToContact: "Suivant : coordonnées",
	backToAddress: "Retour à l'adresse",
	backToRoofType: "Retour au type de toit",
	backToTeaser: "Retour à l'aperçu",
	backToOfferings: "Retour aux offres",
	teaserHeading: "Votre potentiel solaire personnel",
	teaserSubheading: "Sur la base de ces données, nous préparerons votre offre individuelle.",
	offeringsHint: "Ces options seront discutées en détail lors de votre consultation personnelle.",
	solarSuitability: "Aptitude solaire",
	solarExcellent: "Excellent",
	solarVeryGood: "Très bon",
	solarGood: "Bon",
	solarMedium: "Moyen",
	solarLow: "Faible",
	addAnotherRoof: '+ Ajouter un autre toit',
	enterAddressHint: 'Entrez votre adresse ou sélectionnez votre toit sur la carte',
	doubleClickHint: 'Double-clic sur un bâtiment = sélectionner tout le toit',
	doubleTapHint: 'Double-tap sur un bâtiment = sélectionner tout le toit',
	maxRoofsReached: "Maximum 3 toits atteint. Plus de toits ? Veuillez le mentionner dans le champ remarques – un expert solaire s'occupera de votre projet.",
}
